import { render, staticRenderFns } from "./DocumentPreviewModal.vue?vue&type=template&id=f854aca8&scoped=true"
import script from "./DocumentPreviewModal.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewModal.vue?vue&type=style&index=0&id=f854aca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f854aca8",
  null
  
)

export default component.exports